/**
 * Opens or downloads a PDF from an Axios blob response,
 * preserving the filename from Content-Disposition header.
 *
 * @param {Object} response - Axios response with responseType: "blob"
 * @param {string} fallbackName - Fallback filename if Content-Disposition is missing
 */
export function openPdfBlob(response, fallbackName = "document.pdf") {
  const disposition = response.headers["content-disposition"];
  let filename = fallbackName;

  if (disposition) {
    const match = disposition.match(/filename[^;=\n]*=["']?([^"';\n]+)/);
    if (match && match[1]) {
      filename = match[1].trim();
    }
  }

  const blob = new Blob([response.data], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  window.URL.revokeObjectURL(url);
}
